import React from "react";

import { InfoPlate } from "fe-shared/src/components";
import { RequestStatusBadge } from "fe-shared-requests/src/components";
import { formatRequestNumber } from "fe-shared-requests/src/helpers/format";
import { PickupRequestStatus } from "fe-shared-requests/src/types";

import styles from "./RequestStatusHeader.module.scss";

interface Props {
  requestNumber: string;
  status: PickupRequestStatus;
}

// The portal's equivalent carries the assignee control as well; a participant may not assign, so
// this is the number and the status only.
const RequestStatusHeader = ({ requestNumber, status }: Props) => (
  <div className={styles.header}>
    <InfoPlate variant="black">{formatRequestNumber(requestNumber)}</InfoPlate>
    <RequestStatusBadge status={status} className={styles.status} />
  </div>
);

export default RequestStatusHeader;
